<template>
  <!-- <div @click="setFocus(-1)"> -->
  <div>
    <s-header>
      <div class="mt-3 -mb-3">Transfers</div>
    </s-header>

    <section class="flex flex-row justify-start">
      <s-button
        left-icon="file-plus"
        class="mt-3 mb-6 mr-6 shadow-lg z-0"
        @click="$modal.show('modal--product-transfer')"
      >
        Request Transfer
      </s-button>
    </section>

    <section v-if="requestedTransfers.length > 0" class="mt-6">
      <div
        class="text-xl sm:text-2xl font-semibold text-gray-600 mb-3 uppercase"
      >
        REQUESTS
      </div>
      <transfer
        v-for="(id, index) in requestedTransfers"
        :key="id"
        :transfer-id="id"
        :index="index"
        :active-item="activeChild"
        @focused="setFocus"
        class="first:mt-0 mt-4"
      />
    </section>

    <section v-if="inTransitTransfers.length > 0" class="mt-6">
      <div
        class="text-xl sm:text-2xl font-semibold text-gray-600 mb-3 uppercase"
      >
        IN TRANSIT
      </div>
      <transfer
        v-for="(id, index) in inTransitTransfers"
        :key="id"
        :transfer-id="id"
        :index="index + requestedTransfers.length"
        :active-item="activeChild"
        @focused="setFocus"
        class="first:mt-0 mt-4"
      />
    </section>

    <section v-if="completedTransfers.length > 0" class="mt-6">
      <div
        class="text-xl sm:text-2xl font-semibold text-gray-600 mb-3 uppercase"
      >
        COMPLETED
      </div>
      <transfer
        v-for="(id, index) in completedTransfers"
        :key="id"
        :transfer-id="id"
        :index="index + requestedTransfers.length + inTransitTransfers.length"
        :active-item="activeChild"
        @focused="setFocus"
        class="first:mt-0 mt-4"
      />
    </section>

    <section
      v-if="
        !requestedTransfers.length &&
        !inTransitTransfers.length &&
        !completedTransfers.length
      "
      class="mt-8 sm:mt-8 px-6 py-2 text-lg sm:text-2xl font-semibold text-gray-800 text-left leading-tight border-l-4 border-gray-800"
    >
      Currently there are no transfers.
    </section>
  </div>
</template>

<script>
import SHeader from '@/components/SHeader'
import SButton from '@/components/Button'
import Transfer from '@/components/Transfer'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TransferList',
  data() {
    return {
      activeChild: -1
    }
  },
  components: {
    SHeader,
    SButton,
    Transfer
  },
  computed: {
    ...mapGetters('user', ['isManager', 'isStaff', 'storeName']),
    ...mapGetters('storeModule/transfers', [
      'transfers',
      'transfersOrdered',
      'pendingTransfersCount',
      'isTransfer',
      'transfersByStoreId'
    ]),
    ...mapGetters('storeModule/waste', ['wasteOrdered']),

    storeTransfers() {
      return this.transfersByStoreId(this.storeName)
    },

    requestedTransfers() {
      return this.storeTransfers
        .filter((t) => t.status === 'requested')
        .map((t) => t.id)
    },

    inTransitTransfers() {
      return this.storeTransfers
        .filter((t) => t.status === 'approved')
        .map((t) => t.id)
    },

    completedTransfers() {
      return this.storeTransfers
        .filter((t) => t.status === 'completed')
        .map((t) => t.id)
    }
  },
  methods: {
    ...mapActions('reports', ['exportTransactionData']),

    setFocus(id) {
      this.activeChild = id
    },
    async handleExport() {
      try {
        const transfers = this.transfersOrdered
        const waste = this.wasteOrdered
        const startDate = new Date() // You might want to add date filtering
        const endDate = new Date()

        await this.exportTransactionData({
          transfers,
          waste,
          startDate,
          endDate
        })
      } catch (error) {
        console.error('Error exporting transactions:', error)
        this.$modal.show('modal--message', {
          title: 'Error',
          message: 'Failed to export transactions'
        })
      }
    }
  }
}
</script>
